import { parseHTML } from 'linkedom';

/**
 * Splits legacy Webflow news body HTML into prose, embedded videos, and images.
 * Images are removed from prose so they can render in a carousel.
 * Uses linkedom so parsing works during Next.js SSR (no browser DOMParser).
 */
function parseDocument(html) {
  const { document } = parseHTML('<!DOCTYPE html><html><body></body></html>');
  document.body.innerHTML = html;
  return document;
}

export default function parseNewsArticleBody(html) {
  if (!html?.trim()) {
    return { proseHtml: '', videos: [], images: [] };
  }

  const doc = parseDocument(html);
  const videos = [];
  const images = [];
  const seenImageSrc = new Set();

  doc
    .querySelectorAll('figure.w-richtext-figure-type-video iframe, figure iframe')
    .forEach(iframe => {
      const src = iframe.getAttribute('src')?.trim();
      if (src) {
        videos.push({ src });
      }
      iframe.closest('figure')?.remove();
    });

  doc.querySelectorAll('figure.w-richtext-figure-type-image img, figure img').forEach(img => {
    const src = img.getAttribute('src')?.trim();
    if (src && !seenImageSrc.has(src)) {
      seenImageSrc.add(src);
      images.push({
        src,
        alt: img.getAttribute('alt')?.trim() || '',
      });
    }
    img.closest('figure')?.remove();
  });

  doc.querySelectorAll('img').forEach(img => {
    const src = img.getAttribute('src')?.trim();
    if (src && !seenImageSrc.has(src)) {
      seenImageSrc.add(src);
      images.push({
        src,
        alt: img.getAttribute('alt')?.trim() || '',
      });
    }
    img.remove();
  });

  doc.body.querySelectorAll('p').forEach(node => {
    const text = node.textContent?.replace(/\u200d/g, '').trim();
    if (!text) {
      node.remove();
    }
  });

  return {
    proseHtml: doc.body.innerHTML.trim(),
    videos,
    images,
  };
}
